export default "__VITE_ASSET__ac59cc28__"